'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Odaberite vrijeme'
};

exports['default'] = locale;